"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

require("./Card.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
*
* Card
*
*/
function Card(_ref) {
  var title = _ref.title,
      children = _ref.children,
      className = _ref.className,
      _ref$zDepth = _ref.zDepth,
      zDepth = _ref$zDepth === void 0 ? 1 : _ref$zDepth,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className || ''
  }, /*#__PURE__*/_react["default"].createElement(_material.Paper, {
    elevation: zDepth,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Card_container"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "Card_cardTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Card_children"
  }, children))));
}

Card.propTypes = {
  title: _propTypes["default"].string,
  className: _propTypes["default"].string,
  zDepth: _propTypes["default"].number,
  onClick: _propTypes["default"].func,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func
};
var _default = Card;
exports["default"] = _default;